
import Navigo from 'navigo'
const user = require('../../../main.config.js')

const router = new Navigo(user.paths.basepath)
router.path = () => window.location.href

export default router
